import {Component} from '@angular/core';
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import {Filterresponse} from "../../../Interfaces/filterresponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {Filter} from "../../../Interfaces/filter.interface";
import {HttpClient} from "@angular/common/http";
import Helper from "../../../Helper/Helper";
import {TokenStorageService} from "../../../services/token-storage.service";

@Component({
  selector: 'app-filterkategorien',
  templateUrl: './filterkategorien.component.html'
})
export class FilterkategorienComponent {

  public industry: Filter[] | undefined
  public contracttypes: Filter[] | undefined
  public timemodels: Filter[] | undefined
  public education: Filter[] | undefined
  public carrerlevel: Filter[] | undefined
  public remote: Filter[] | undefined

  public filters: Filterresponse[] | undefined

  public selectedcategory: string = "industry"

  constructor(private httpClient: HttpClient, private tokenStorage: TokenStorageService) {
    this.loadFilterkategorien("id", "asc")
  }

  public loadFilterkategorien(sortby: string = "", sorttype: string = "") {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    this.httpClient.get<RestResponse<Filterresponse[]>>(RestHelper.API_BASE_URL + "searchfilter/getSearchFilter?admin=true&" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
      next: (value) => {

        // console.log(value.data.filter(value1 => value1.filterName === "contracttype").at(0)!.filter)

        this.industry = value.data.filter(value1 => value1.filterName === "industry")?.at(0)?.filter
        this.contracttypes = value.data.filter(value1 => value1.filterName === "contract_type")?.at(0)?.filter
        this.timemodels = value.data.filter(value1 => value1.filterName === "timemodel")?.at(0)?.filter
        this.education = value.data.filter(value1 => value1.filterName === "education")?.at(0)?.filter
        this.carrerlevel = value.data.filter(value1 => value1.filterName === "carrer_level")?.at(0)?.filter
        this.remote = value.data.filter(value1 => value1.filterName === "remote")?.at(0)?.filter

        this.filters = value.data

      }, error: (err) => {
        console.log(err)
      }
    })
  }

  public changeStatus(event: Event, id: number) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("category", this.selectedcategory)
    body.append("id", id.toString())
    body.append("active", String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'searchfilter/updateFilter?admin=true', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public getFilterValues(filterName: string): Filter[] | undefined {
    return this.filters?.filter(value1 => value1.filterName === filterName)!.at(0)!.filter
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.loadFilterkategorien(property, sorttype)
  }

  protected readonly Helper = Helper;
}
